import {Button, ButtonGroup, Table} from "@chakra-ui/react";
import {Form, UI} from "components";
import {useState} from "react";
import Moment from "moment/moment";
import useReportFinancial from "hooks/useReportFinancial";
import useExportReportType from "hooks/useExportReportType";

export default function AnalyticsFinancial() {
    const initialPeriod = [
        Moment().startOf("month").toDate(),
        Moment().endOf("month").toDate()
    ];
    const [period, setPeriod] = useState(initialPeriod)

    const validPeriod =
        period && period[0] instanceof Date && period[1] instanceof Date
            ? [Moment(period[0]).format('YYYY-MM-DD'), Moment(period[1]).format('YYYY-MM-DD')]
            : null

    const startDate = validPeriod ? validPeriod[0] : null
    const endDate = validPeriod ? validPeriod[1] : null

    const report = useReportFinancial(startDate, endDate)
    const exportReport = useExportReportType()

    const financialData = report.data?.months
        ? Object.entries(report.data.months).map(([month, value]) => ({
            month,
            sales: value.financial?.sales || 0,
            debits: value.financial?.debits || 0,
            in_person: value.financial?.in_person || 0,
            bonus: value.financial?.bonus || 0,
            pix: value.financial?.pix || 0
        }))
        : report.data?.financial
            ? [{
                month: Moment(validPeriod?.[0]).format('MM/YYYY'),
                sales: report.data.financial.sales || 0,
                debits: report.data.financial.debits || 0,
                in_person: report.data.financial.in_person || 0,
                bonus: report.data.financial.bonus || 0,
                pix: report.data.financial.pix || 0
            }]
            : []

    const columns = [
        {children: 'Mês'},
        {children: 'Total em vendas', textAlign: 'right'},
        {children: 'Saldo utilizado', textAlign: 'right'},
        {children: 'Presencial', textAlign: 'right'},
        {children: 'Bonificação', textAlign: 'right'},
        {children: 'Pix', textAlign: 'right'},
    ]

    const handleResetFilters = () => {
        setPeriod(initialPeriod)
    }

    const handleExportReportType = (reportType, exportMine) => {
        if (startDate && endDate) {
            exportReport.mutate({
                reportType,
                exportMine,
                startDate,
                endDate,
            })
        }
    }

    const handleExportCsv = () => {
        if (!financialData.length) return;

        const header = [
            "Mês",
            "Total em vendas",
            "Saldo utilizado",
            "Presencial",
            "Bonificação",
            "Pix"
        ];

        const formatCurrency = (value) => {
            const numberValue = value / 100;
            return numberValue.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            });
        };

        const csvContent = [
            header.join(";"),
            ...financialData.map((item) => [
                item.month,
                formatCurrency(item.sales),
                formatCurrency(item.debits),
                formatCurrency(item.in_person),
                formatCurrency(item.bonus),
                formatCurrency(item.pix)
            ].join(";"))
        ].join("\n");

        const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `relatorio-financeiro-${Moment(startDate).format('DD-MM-YYYY')}-a-${Moment(endDate).format('DD-MM-YYYY')}.csv`;
        link.click();
        URL.revokeObjectURL(link.href);
    };

    return (
        <>
            <UI.Header title="Resumo Financeiro"/>

            <UI.Table
                loading={report.isFetching}
                loadingText="Buscando resumo financeiro..."
                label="Resumo financeiro:"
                columns={columns}
                data={financialData}
                Row={Row}
            >
                <ButtonGroup>
                   {/* <Button
                        loading={exportReport.isPending}
                        loadingText="Download do arquivo..."
                        variant="subtle"
                        colorPalette="green"
                        onClick={() => handleExportReportType('reportsFinancialExport', 'pdf')}
                    >
                        <UI.Icon name="pdf"/>
                        Exportar Pdf
                    </Button>*/}
                    <Button
                        loading={exportReport.isPending}
                        loadingText="Download do arquivo..."
                        variant="subtle"
                        colorPalette="blue"
                        onClick={handleExportCsv}
                    >
                        <UI.Icon name="csv"/>
                        Export CSV
                    </Button>
                </ButtonGroup>

                <Form.Interval
                    initial={initialPeriod}
                    onSelect={(p) => setPeriod(p)}
                />

                <UI.Show visible={!!validPeriod}>
                    <Button variant="ghost" size="xs" onClick={handleResetFilters}>
                        <UI.Icon name="cancel"/> Limpar filtros
                    </Button>
                </UI.Show>
            </UI.Table>
        </>
    )
}

const Row = ({data}) => {
    return (
        <Table.Row>
            <Table.Cell fontSize="xs">{data?.month}</Table.Cell>
            <Table.Cell textAlign="right" fontWeight="bold">
                <UI.Number.Amount value={data?.sales}/>
            </Table.Cell>
            <Table.Cell textAlign="right">
                <UI.Number.Amount value={data?.debits}/>
            </Table.Cell>
            <Table.Cell textAlign="right">
                <UI.Number.Amount value={data?.in_person}/>
            </Table.Cell>
            <Table.Cell textAlign="right">
                <UI.Number.Amount value={data?.bonus}/>
            </Table.Cell>
            <Table.Cell textAlign="right">
                <UI.Number.Amount value={data?.pix}/>
            </Table.Cell>
        </Table.Row>
    )
}